export * from "./ManagementPrimSpecs";
